// extracted by mini-css-extract-plugin
export const nav = "layout-module--nav--23k0a";
export const logo = "layout-module--logo---MXHy";
export const navList = "layout-module--navList--3xw6m";
export const navItem = "layout-module--navItem--2ZHXu";
export const navItemLink = "layout-module--navItemLink--bZ3tZ";
export const navItemLinkActive = "layout-module--navItemLinkActive--3B6yr";
export const footer = "layout-module--footer--3iD_9";
export const copyright = "layout-module--copyright--2swj1";